var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgISlModule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.025,
    height: 21.035,
    viewBox: "0 0 15.025 21.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11916",
    "data-name": "Group 11916",
    transform: "translate(-12 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(20.513 10.518)",
    fill: "#3f63f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(17.513 10.518)",
    fill: "#3f63f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49540",
    "data-name": "Path 49540",
    d: "M25.522,4H13.5A1.5,1.5,0,0,0,12,5.5v18.03a1.5,1.5,0,0,0,1.5,1.5h12.02a1.5,1.5,0,0,0,1.5-1.5V5.5A1.5,1.5,0,0,0,25.522,4ZM14.254,10.01a.377.377,0,0,1,.376-.376h1.127V8.883a.377.377,0,0,1,.376-.376h3V7.275a.751.751,0,1,1,.751,0V8.507h3a.377.377,0,0,1,.376.376v.751H24.4a.377.377,0,0,1,.376.376v1.878a.377.377,0,0,1-.376.376H23.269v1.127a.377.377,0,0,1-.376.376H16.132a.377.377,0,0,1-.376-.376V12.264H14.629a.377.377,0,0,1-.376-.376ZM25.522,23.157H13.5a.376.376,0,0,1,0-.751h12.02a.376.376,0,1,1,0,.751Zm0-2.254H13.5a.376.376,0,0,1,0-.751h12.02a.376.376,0,1,1,0,.751Zm0-2.254H13.5a.376.376,0,0,1,0-.751h12.02a.376.376,0,1,1,0,.751Zm0-2.254H13.5a.376.376,0,0,1,0-.751h12.02a.376.376,0,1,1,0,.751Z",
    fill: "#3f63f1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgISlModule);
export default __webpack_public_path__ + "static/media/iSL Module.f74957e228c50e4f1421343705473f0e.svg";
export { ForwardRef as ReactComponent };